import { ROUTES } from 'src/constants';

import { match, history } from 'utils';

function isCreateDistance() {
  return match(history.location.pathname, { path: ROUTES.newDistanceRoute });
}

export { isCreateDistance };
